import * as THREE from 'three';
import { Sweep, Vector3 } from 'src/types';
import { CombinedSweep } from '../types';

export const getSweepSid = (
  sweep: Sweep.ObservableSweepData & { sweep?: string },
  sweeps: Map<string, CombinedSweep>,
  legacyIds: boolean,
) => {
  if (legacyIds) {
    let sweepId;
    sweeps.forEach((value, key) => {
      if (value.sweep_uuid === sweep.sid || value.sweep_uuid === sweep.sweep) {
        sweepId = key;
      }
    });
    return sweepId;
  } else {
    return sweep?.sid ? sweep?.sid : sweep?.sweep;
  }
};

export const getAzimuthAngle = (point1: Vector3, point2: Vector3, point3: Vector3) => {
  const p1 = new THREE.Vector3(point1.x, 0, point1.z);
  const p2 = new THREE.Vector3(point2.x, 0, point2.z);
  const p3 = new THREE.Vector3(point3.x, 0, point3.z);

  const vector21 = new THREE.Vector3().subVectors(p1, p2).normalize();
  const vector23 = new THREE.Vector3().subVectors(p3, p2).normalize();

  const angle = vector21.angleTo(vector23);
  const crossProduct = new THREE.Vector3().crossVectors(vector21, vector23).y;

  return { angle, crossProduct };
};

export const stepsInSameTeleportGroup = (matterPathStep1, matterPathStep2, teleportGroups) => {
  return teleportGroups.some((group) => {
    const groupSweeps = group.pointNodes.map((point) => point.sweep);
    return (
      groupSweeps.includes(matterPathStep1.data.id) && groupSweeps.includes(matterPathStep2.data.id)
    );
  });
};

export const getCurveLength = (curve) => {
  const point1 = curve.getPointAt(0);
  const point2 = curve.getPointAt(1);

  // Calculate the Euclidean distance between the two points
  return point1.distanceTo(point2);
};

export const calculateSubsegments = (parentLength, subsegmentLength) => {
  const subsegments = Math.ceil(parentLength / subsegmentLength);
  const subsegmentLengthActual = parentLength / subsegments;
  return { subsegments, subsegmentLengthActual };
};
